import type { RouteRecordRaw } from 'vue-router'

import { INSURANCE } from './routes.constants'

const routes: RouteRecordRaw[] = [
  {
    path: 'post-purchase/insurance/:policyId/due',
    name: INSURANCE.DUE_PAYMENT,
    component: () => import('./pages/DueInsurance/DueInsurance.vue'),
    meta: {
      owners: ['bot-squad-b2cservices-front'],
      layout: false,
      auth: {
        required: true,
      },
    },
  },
  {
    path: 'post-purchase/insurance/:policyId/due/result',
    name: INSURANCE.DUE_PAYMENT_RESULT,
    component: () =>
      import('./pages/DueInsurance/DueInsurancePaymentResult.vue'),
    meta: {
      owners: ['bot-squad-b2cservices-front'],
      auth: {
        required: true,
      },
    },
  },
  {
    path: 'post-purchase/insurance/due/completed',
    name: INSURANCE.DUE_PAYMENT_COMPLETED,
    component: () => import('./pages/DueInsurance/DueInsuranceCompleted.vue'),
    meta: {
      owners: ['bot-squad-b2cservices-front'],
      auth: {
        required: true,
      },
    },
  },
  {
    path: 'post-purchase/insurance',
    name: INSURANCE.POST_PURCHASE,
    component: () => import('./pages/PostPurchase/PostPurchase.vue'),
    meta: {
      owners: ['bot-squad-b2cservices-front'],
      layout: false,
      auth: {
        required: true,
      },
    },
  },
  {
    path: 'post-purchase/insurance/expired',
    name: INSURANCE.EXPIRED,
    component: () => import('./pages/Expired/Expired.vue'),
    meta: {
      owners: ['bot-squad-b2cservices-front'],
    },
  },

  // Backwards compatible route for old url
  {
    path: 'checkout',
    redirect: ({ query }) => ({ name: INSURANCE.POST_PURCHASE, query }),
    meta: {
      owners: ['bot-squad-b2cservices-front'],
    },
  },
]

export default routes
